/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const InvertIcon = ({ width = 24, height = 24, hidden = false, title = 'Invert' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m10,9.25h-3.27478l.92224-.98828c.2832-.30273.2666-.77734-.03613-1.06055-.30176-.28125-.77734-.26562-1.05957.03711l-2.09961,2.25c-.26953.28809-.26953.73535,0,1.02344l2.09961,2.25c.14746.1582.34766.23828.54785.23828.18359,0,.36719-.06641.51172-.20117.30273-.2832.31934-.75781.03613-1.06055l-.92224-.98828h3.27478v-1.5Z"
      fill="currentColor"
    />
    <path
      d="m15.75,2H4.25c-1.24023,0-2.25,1.00977-2.25,2.25v11.5c0,1.24023,1.00977,2.25,2.25,2.25h11.5c1.24023,0,2.25-1.00977,2.25-2.25V4.25c0-1.24023-1.00977-2.25-2.25-2.25ZM3.5,15.75V4.25c0-.41309.33691-.75.75-.75h5.75v5.75h3.27478l-.92224-.98828c-.2832-.30273-.2666-.77734.03613-1.06055.30176-.28125.77637-.26562,1.05957.03711l2.09961,2.25c.26953.28809.26953.73535,0,1.02344l-2.09961,2.25c-.14746.1582-.34766.23828-.54785.23828-.18359,0-.36719-.06641-.51172-.20117-.30273-.2832-.31934-.75781-.03613-1.06055l.92224-.98828h-3.27478v5.75h-5.75c-.41309,0-.75-.33691-.75-.75Z"
      fill="currentColor"
    />
  </svg>`;
};
